import { RouterProvider } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import router from 'routes';
import Locales from 'ui-component/Locales';
import NavigationScroll from 'layout/NavigationScroll';
import Notistack from 'ui-component/third-party/Notistack';
import { queryClient } from 'api/queryClient';
import ThemeCustomization from 'themes';
import { msalInstance, scopes } from 'config/authConfig';
import { MsalAuthenticationTemplate, MsalProvider } from '@azure/msal-react';
import { PermissionProvider } from 'contexts/PermissionProviderContext';
import { InteractionType } from '@azure/msal-browser';
import { MsalAuthErrorComponent } from 'views/common/MsalAuthErrorComponent';
import { env } from 'config/env';

export default function App() {
  const appShell = (
    <ThemeCustomization>
      <Locales>
        <NavigationScroll>
          <Notistack>
            <QueryClientProvider client={queryClient}>
              <PermissionProvider>
                <RouterProvider router={router} />
              </PermissionProvider>
            </QueryClientProvider>
          </Notistack>
        </NavigationScroll>
      </Locales>
    </ThemeCustomization>
  );

  if (env.VITE_APP_LOCAL_DEV_AUTH === 'true') {
    return appShell;
  }

  return (
    <MsalProvider instance={msalInstance}>
      <ThemeCustomization>
        <Locales>
          <NavigationScroll>
            <Notistack>
              <QueryClientProvider client={queryClient}>
                <MsalAuthenticationTemplate
                  interactionType={InteractionType.Redirect}
                  authenticationRequest={{ scopes: scopes }}
                  errorComponent={MsalAuthErrorComponent}
                >
                  <PermissionProvider>
                    <RouterProvider router={router} />
                  </PermissionProvider>
                </MsalAuthenticationTemplate>
              </QueryClientProvider>
            </Notistack>
          </NavigationScroll>
        </Locales>
      </ThemeCustomization>
    </MsalProvider>
  );
}
